import { render, staticRenderFns } from "./service-agree-footer.modal.vue?vue&type=template&id=01500e4e&"
import script from "./service-agree-footer.modal.vue?vue&type=script&lang=ts&"
export * from "./service-agree-footer.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports